export class DialogResultConstant {

  //#region Properties

  public static readonly dismissed = 'DISMISS';

  public static readonly manuallyClosed = 'MANUALLY_CLOSED';

  public static readonly automaticallyClosed = 'AUTOMATICALLY_CLOSED';

  //#endregion

}
